import React from "react";
import classNames from "classnames";
import { DraftboxPost } from "../models/draftbox-post-description.model";
import { navigate } from "gatsby";

const truncate = ( str: string, n: number, useWordBoundary: boolean) => {
  if (str.length <= n) { return str; }
  const subString = str.substr(0, n-1); // the original check
  return (useWordBoundary 
    ? subString.substr(0, subString.lastIndexOf(" ")) 
    : subString) + "&hellip;";
};

const getExcerpt = (post: DraftboxPost) => {
  let excerpt;
  if (post.customExcerpt) {
    excerpt =
      post.customExcerpt.length > 140
        ? truncate(post.customExcerpt, 140, true)
        : post.customExcerpt;
  } else if (post.excerpt) {
    excerpt =
      post.excerpt.length > 137
        ? truncate(post.excerpt, 140, true)
        : post.excerpt;
  } else {
    excerpt = "";
  }
  return excerpt;
};

type NextPrevPostProps = {
  prevPost: DraftboxPost;
  nextPost: DraftboxPost;
};
const NextPrevPost: React.FC<NextPrevPostProps> = ({ prevPost, nextPost }) => {
  let nextPostExcerpt = nextPost ? getExcerpt(nextPost) : null;
  let prevPostExcerpt = prevPost ? getExcerpt(prevPost) : null;
  const handleNavigation = (e: any, slug) => {
    e.stopPropagation();
    if (slug !== "#") {
      navigate(slug);
    }
  };
  return (
    <>
      {(prevPost?.postSeoSlug || nextPost?.postSeoSlug) && (
        <>
          <aside className="px-6 max-w-4xl mx-auto flex flex-wrap mt-10">
            <a
              aria-label="Go to next post"
              className={classNames(
                "w-full md:w-1/2 px-4 relative py-4 border-t border-b",
                {
                  "pointer-events-none hidden md:block": !nextPost,
                  "py-4 cursor-pointer": nextPost,
                }
              )}
              // href={nextPost?.postSeoSlug ? `/${nextPost.postSeoSlug}` : "#"}
              onClick={(e) => handleNavigation(e, nextPost?.postSeoSlug ? `/${nextPost.postSeoSlug}` : "#")}
            >
              {nextPost && (
                <section className="h-full flex flex-col">
                  <i className="icon icon-arrow-left"></i>
                  <h2 className="text-xl font-sansBold mb-2 text-gray-800">
                    {nextPost.title}
                  </h2>
                  <p className="mb-2 prev-next-post text-gray-700 font-serifLight break-words">
                    {nextPostExcerpt}
                  </p>
                  <p className="text-gray-700 text-xs mt-auto">
                    <time dateTime="{{date format='DD-MM-YYYY'}}">
                      {nextPost.publishedAt}
                    </time>
                  </p>
                </section>
              )}
            </a>

            <a
              aria-label="Go to previous post"
              className={classNames(
                "w-full md:w-1/2 px-4 relative md:border-l md:border-t border-b",
                {
                  "pointer-events-none hidden md:block": !prevPost,
                  "py-4 cursor-pointer": prevPost,
                  "border-t": !nextPost,
                }
              )}
              onClick={(e) => handleNavigation(e, prevPost?.postSeoSlug ? `/${prevPost.postSeoSlug}` : "#")}
              //href={prevPost?.postSeoSlug ? `/${prevPost.postSeoSlug}` : "#"}
            >
              {prevPost && (
                <section className="h-full flex flex-col">
                  <i className="icon icon-arrow-right"></i>
                  <h2 className="text-xl font-sansBold mb-2 text-gray-800">
                    {prevPost.title}
                  </h2>
                  <p className="mb-2 prev-next-post text-gray-700 font-serifLight break-words">
                    {prevPostExcerpt}
                  </p>
                  <p className="text-gray-700 text-xs mt-auto">
                    <time dateTime="{{date format='DD-MM-YYYY'}}">
                      {prevPost.publishedAt}
                    </time>
                  </p>
                </section>
              )}
            </a>
          </aside>
        </>
      )}
    </>
  );
};

export default NextPrevPost;
